import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackspace = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 20,
	fill: "none",
	viewBox: "0 0 28 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M25 18H8.2l-5.8-8 5.8-8h17v16zm1.1-18H7.6a1 1 0 0 0-.9.4l-6.5 9a1 1 0 0 0 0 1.2l6.5 9c.2.2.5.4.9.4H26c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM11.3 14c.2.2.4.3.7.3.3 0 .5-.1.7-.3l2.7-2.6 2.7 2.6c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.5L17 10l2.6-2.5c.4-.4.4-1 0-1.5a1 1 0 0 0-1.4 0l-2.7 2.6L12.7 6a1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.5l2.6 2.5-2.6 2.5a1 1 0 0 0 0 1.5z",
		clipRule: "evenodd"
	})
});
export default SvgBackspace;
